const SITE_SEARCH_TERM = (state, siteSearchTerm) => {
  state.siteSearchTerm = siteSearchTerm;
};

const PORTFOLIO_SITES = (state, portfolioSites) => {
  state.portfolioSites = portfolioSites;
  // Distinguishes "fetched successfully but user has zero sites" from
  // "not fetched yet / fetch failed".
  state.portfolioSitesLoaded = true;
};

export default {
  SITE_SEARCH_TERM,
  PORTFOLIO_SITES,
};
